import { useQuery, useQueryClient } from "@tanstack/react-query";
import useApiHelper from "../hooks/useApiHelper";
import { VehicleStatsResponse } from "../models/Vehicle";
import { DefaultResponseWithData } from "../models/system";

export default function useVehicleStats(filters?: any, pageName?: string) {
  const { get } = useApiHelper();
  const queryClient = useQueryClient();


  const stats = useQuery(["vehicle", "stats"], () => get<DefaultResponseWithData<VehicleStatsResponse>>(`/stats/vehicle`), {
    onSuccess: () => {
    },
    // 5 mins
    staleTime: 300000,
  });

  return { stats };
}